import { CollectionView } from "backbone.marionette";

import { Category } from "./category";

export const CategoriesList = CollectionView.extend({
    className: "categories",
    childView: Category,
    childViewTriggers: {
        "clicked:item": "clicked:item",
        "treeitem:selected": "treeitem:selected"
    },
    viewComparator: "alias",
    initialize() {
        this.childViewOptions = {
            parent: this.getOption("parent")
        };
    }
});
